import React, { useState } from 'react';
import './index.scss';

import girl from './images/girl.png'

function Main() {
  const [formState, setFormState] = useState({
    name: '',
    _replyto: '',
    message: '',
    subject: ''
  })

  const [alert, setAlert] = useState(null)

  const onChange = (name) => (event) => {
    setFormState({
      ...formState,
      [name]: event.target.value
    })
  }

  const submitForm = (event) => {
    event.preventDefault()

    setAlert(null);
    fetch('https://formspree.io/mpzpgnvz', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(formState)
    })
      .then((response) => {
        return response.json()
          .then((parsed) => {
            if (parsed.ok) {
              setAlert("Thank you for your message, I'll respond shortly.");
            } else {
              console.log(parsed);
              setAlert(parsed.error);
            }
          })
      })
      .catch(() => {
        setAlert('Something went wrong :-( Please try again, or send a direct email!');
      })
  }

  return (
    <main className="page-Contact">
      <section className="left">
        <img alt="Drawing of a girl with a phone" src={girl}/>
      </section>

      <section className="right">
        <h2 className="email">lanabatyrova7@gmail.com</h2>

        <form>
          <input type="text" placeholder="Name" onChange={onChange('name')} value={formState['name']}/>
          <input type="email" placeholder="Email" onChange={onChange('_replyto')} value={formState['_replyto']}/>
          <input type="text" placeholder="Subject" onChange={onChange('subject')} value={formState['subject']}/>

          <textarea placeholder="Message" onChange={onChange('message')} value={formState['message']}/>

          <button type="button" onClick={submitForm}>
            Send
          </button>
        </form>

        {
          alert &&
          <div className="alert">{alert}</div>
        }
      </section>
    </main>
  );
}

export default Main;
